<div class="nav-container">
  <p>
    {{
      editing
        ? translationService.getEditProductText()
        : translationService.getAddProductText()
    }}
  </p>
  <nav class="nav-list">
    @for (section of productSteps; track $index) {
      <div
        [ngClass]="
          currentStep === $index ? 'nav-item current' : 'nav-item inactive'
        "
        (click)="navigateOnClick($index)"
        (keyup)="navigateOnClick($index)"
        tabindex="0"
      >
        <p
          [ngClass]="
            stepDisabled($index)
              ? 'disabled dark-link bold-600 medium-font'
              : 'enabled dark-link bold-600 medium-font'
          "
        >
          <!-- {{ $index + 1 + ' ' + section }} -->
          {{ section }}
        </p>
      </div>
    }
  </nav>
</div>
